import { UserLearningPath } from 'views/LearningPath/UserLearningPath/UserLearningPath';
// import { UserLearningPaths } from 'views/LearningPath/UserLearningPaths/UserLearningPaths';
// import { LPathPurchase } from 'views/LearningPath/LPathPurchase/LPathPurchase';
import { LPathInfo } from 'views/LearningPath/LPathPurchase/LPathInfo';
// import { LPathOrgPurchase } from 'views/LearningPath/LPathOrgPurchase/LPathOrgPurchase';
import { LPathView } from 'views/LearningPath/LPathView';


const routes = [
	{
		path: '/lpaths',
		view: LPathView,
		layout: 'app',
		permission: 'lpath.view',
		title: 'LearningPath.UserLearningPaths.title'
	},
	{
		path: 'lpaths/:lpath_id/learningpath',
		view: UserLearningPath,
		layout: 'app',
		permission: 'lpath.user.view',
		title: 'LearningPath.UserLearningPath.title'
	},
	// {
	// 	path: '/lpaths/purchase',
	// 	view: LPathPurchase,
	// 	layout: 'app',
	// 	permission: 'scholar',
	// 	title: 'LearningPath.LPathPurchase.title.purchase'
	// },
	// {
	// 	path: '/lpaths/org',
	// 	view: LPathOrgPurchase,
	// 	layout: 'app',
	// 	permission: 'scholar',
	// 	title: 'LearningPath.LPathPurchase.title.enroll'
	// },
	{
		path: '/lpaths/info/:lpath_id',
		view: LPathInfo,
		layout: 'app',
		permission: 'lpath.info.view',
		title: 'LearningPath.LPathInfo.title.buy'
	},
]

export default routes;